// Validation utility functions for questionnaire form

export const validateForm = (formData) => {
  const newErrors = {};
  const requiredFields = [
    { field: "statusrumah", number: 0 },
    { field: "nomorUrut", number: 1 },
    { field: "nomorRumahPadaPeta", number: 2 },
    { field: "namaLengkapKK", number: 3 },
    { field: "jenisKelamin", number: 5 },
    { field: "nomorKK", number: 6 },
    { field: "nomorKTP", number: 7 },
    { field: "asalKTP", number: 8 },
    { field: "jumlahKK", number: 9 },
    { field: "jumlahPenghuni", number: 10 },
    { field: "alamatRumah", number: 11 },
    { field: "kecamatan", number: 12 },
    { field: "desaKelurahan", number: 13 },
    { field: "pendidikanTerakhir", number: 14 },
    { field: "pekerjaan", number: 15 },
    { field: "fungsiBangunan", number: 16 },
    { field: "penghasilan", number: 17 },
    { field: "statusKepemilikanRumah", number: 18 },
    { field: "asetRumahDiTempatLain", number: 19 },
    { field: "statusKepemilikanTanah", number: 20 },
    { field: "asetTanahDiTempatLain", number: 21 },
    { field: "sumberPenerangan", number: 22 },
    { field: "dayaListrik", number: 23 },
    { field: "bantuanPerumahan", number: 24 },
    { field: "modelRumah", number: 25 },
    { field: "pondasi", number: 26 },
    { field: "kolom", number: 27 },
    { field: "rangkaAtap", number: 28 },
    { field: "plafon", number: 29 },
    { field: "balok", number: 30 },
    { field: "sloof", number: 31 },
    { field: "pintuJendelaKonsen", number: 32 },
    { field: "ventilasi", number: 33 },
    { field: "materialLantaiTerluas", number: 34 },
    { field: "kondisiLantai", number: 35 },
    { field: "materialDindingTerluas", number: 36 },
    { field: "kondisiDinding", number: 37 },
    { field: "materialPenutupAtapTerluas", number: 38 },
    { field: "kondisiPenutupAtap", number: 39 },
    { field: "luasRumah", number: 40 },
    { field: "luasTanah", number: 41 },
    { field: "buanganAirLimbahRumahTangga", number: 42 },
    { field: "saranaPengelolaanLimbahCair", number: 43 },
    { field: "pemiliharaanSaranaPengelolaanLimbah", number: 44 },
    { field: "jenisTempatPembuanganAirTinja", number: 45 },
    { field: "kepemilikanKamarMandiDanJamban", number: 46 },
    { field: "jumlahJamban", number: 47 },
    { field: "jenisKloset", number: 48 },
    { field: "jenisTangkiSeptik", number: 49 },
    { field: "materialTangkiSeptik", number: 50 },
    { field: "alasTangkiSeptik", number: 51 },
    { field: "lubangPenyedotan", number: 52 },
    { field: "posisiTangkiSeptik", number: 53 },
    { field: "jarakTangkiSeptikDenganSumberAir", number: 54 },
    { field: "sumberAirMinum", number: 55 },
    { field: "tanggalPendataan", number: 57 },
    { field: "namaSurveyor", number: 58 },
  ];

  // Validasi setiap field
  requiredFields.forEach(({ field, number }) => {
    if (field === "jumlahJamban" && formData.kepemilikanKamarMandiDanJamban === "Tidak Ada") {
      return;
    }

    if (!formData[field] && formData[field] !== 0) {
      newErrors[field] = `(${number}) ${field.replace(/([A-Z])/g, " $1").toUpperCase()} tidak boleh kosong.`;
    }
  });

  // Validasi spesifik
  if (formData.nomorKK && formData.nomorKK.length !== 16) {
    newErrors.nomorKK = "(6) Nomor KK harus terdiri dari 16 digit.";
  }
  if (formData.nomorKTP && formData.nomorKTP.length !== 16) {
    newErrors.nomorKTP = "(7) Nomor KTP harus terdiri dari 16 digit.";
  }
  if (!formData.titikKoordinatRumah && !formData.manualTitikKoordinatRumah) {
    newErrors.titikKoordinatRumah = "Titik Koordinat Rumah atau Manual Titik Koordinat Rumah harus diisi.";
  } else if (formData.titikKoordinatRumah && formData.manualTitikKoordinatRumah) {
    newErrors.titikKoordinatRumah = "Hanya satu dari Titik Koordinat Rumah atau Manual Titik Koordinat Rumah yang boleh diisi.";
  }
  if (formData.tanggalPendataan) {
    const tanggalPendataan = new Date(formData.tanggalPendataan);
    const hariIni = new Date();
    hariIni.setHours(0, 0, 0, 0);
    tanggalPendataan.setHours(0, 0, 0, 0);

    if (tanggalPendataan > hariIni) {
      newErrors.tanggalPendataan = "Tanggal Pendataan tidak boleh lebih dari tanggal hari ini.";
    }
  }

  return newErrors;
};

export const validateCoordinate = (coordinate) => {
  const regex = /^-?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*-?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)$/;
  return regex.test(coordinate);
};

export const validateCoordinateForSpecificKecamatan = (coordinate, kecamatan) => {
  const allowedKecamatan = ["Maluk", "Jereweh"];

  if (!allowedKecamatan.includes(kecamatan)) {
    return true;
  }

  return coordinate && validateCoordinate(coordinate);
};

export const validateDate = (date) => {
  const datePattern = /^(0[1-9]|[12][0-9]|3[01])[-/](0[1-9]|1[0-2])[-/]\d{4}$/;
  return datePattern.test(date);
};
